
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1en0z_66",
  "button": "awsui_button_vjswe_1en0z_70",
  "variant-normal": "awsui_variant-normal_vjswe_1en0z_132",
  "disabled": "awsui_disabled_vjswe_1en0z_150",
  "variant-primary": "awsui_variant-primary_vjswe_1en0z_157",
  "variant-link": "awsui_variant-link_vjswe_1en0z_182",
  "variant-icon": "awsui_variant-icon_vjswe_1en0z_207",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1en0z_232",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1en0z_257",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1en0z_282",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1en0z_311",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1en0z_336",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1en0z_361",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1en0z_391",
  "button-no-text": "awsui_button-no-text_vjswe_1en0z_483",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1en0z_487",
  "full-width": "awsui_full-width_vjswe_1en0z_490",
  "button-compact": "awsui_button-compact_vjswe_1en0z_507",
  "icon-left": "awsui_icon-left_vjswe_1en0z_517",
  "icon-right": "awsui_icon-right_vjswe_1en0z_522",
  "icon": "awsui_icon_vjswe_1en0z_517",
  "link": "awsui_link_vjswe_1en0z_541",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1en0z_541"
};
  